<template>
    <div>
        <b-row>
            <b-col cols="12" md="6">
                <b-form-group :label="$t('student_name')">
                    <b-input-group>
                        <div class="label-as-input"> {{  isNotNullValue(form.student_name) }}</div>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
                <b-form-group :label="$t('student_name')">
                    <b-input-group>
                        <div class="label-as-input"> {{  isNotNullValue(form.student_surname) }}</div>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
                <b-form-group :label="$t('document_type')">
                    <b-input-group>
                        <div class="label-as-input"> {{  getLocaleText(form,'document_type_name') }}</div>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
                <b-form-group :label="$t('status')">
                    <b-input-group>
                        <div class="label-as-input"> {{ getLocaleText(form, 'status_name') }}</div>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
                <b-form-group :label="$t('excuse_start_date')">
                    <b-input-group>
                        <div class="label-as-input"> {{ form.start_date ? toLocaleDate(form.start_date) : '-' }}</div>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
                <b-form-group :label="$t('excuse_end_date')">
                    <b-input-group>
                        <div class="label-as-input"> {{ form.end_date ? toLocaleDate(form.end_date) : '-' }}</div>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
                <b-form-group :label="$t('approver_name')">
                    <b-input-group>
                        <div class="label-as-input"> {{ isNotNullValue(form.approver_name) }}</div>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
                <b-form-group :label="$t('approver_surname')">
                    <b-input-group>
                        <div class="label-as-input"> {{ isNotNullValue(form.approver_surname) }}</div>
                    </b-input-group>
                </b-form-group>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    //Service
    import PrepStudentDocumentService from '@/services/PrepStudentDocumentService';

    export default {
        props: {
            formId: {
                type: Number
            }
        },
        data() {
            return {
                form: {
                    student_name: null,
                    student_surname: null,
                    document_type: null,
                    status: null,
                    start_date: null,
                    end_date: null,
                    approver_name: null,
                    approver_surname: null,
                }
            }
        },
        async created() {
            await this.get(this.formId)
        },
        methods: {
            get(id) {
                this.formLoading = true;
                PrepStudentDocumentService.get(id)
                                .then((response) => {
                                    this.form = response.data.data;
                                    this.formLoading = false;
                                })
                                .catch((error) => {
                                    this.showErrors(error)
                                });
            }
        }
    }
</script>
